import { Brand } from '@Praia-Health/spi-common-utils/types';
import { useContext } from 'react';
import { ClientConfig } from '../../clientConfig';
import { ClientConfigContext } from '../clientConfigContext';

// Get the brand config from the URL parameters (or from an OIDC state) or fallback on the default brand
export const useBrand = (): Brand => {
    const clientConfiguration = useContext<ClientConfig>(ClientConfigContext);
    return clientConfiguration.brandConfig;
};
